import DonatePointsPopup from './DonatePointsPopup';
import DonatePointsPopupContainer from './DonatePointsPopup.container';

export default DonatePointsPopupContainer(DonatePointsPopup);
